<template>
    <div>
        <Loading v-if="showDataTableLoading" />
        <table class="table table-hover table-separate table-head-custom collapsed" id="data-table">
            <thead>
                <tr>
                    <th>ردیف</th>
                    <th v-for="(column, index) in columns" :key="index" v-text="column.title"></th>
                    <th
                        v-for="(customColumn, index) in customColumns"
                        :key="index + 'customColumn'"
                        v-text="customColumn.title"
                    ></th>
                    <th v-if="rows.hasOwnProperty('hasStatus')">وضعیت</th>
                    <th v-if="rows.hasOwnProperty('operations')">عملیات</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(row, index) in dataTableRows" :key="index">
                    <td>{{ index + 1 + (currentPage > 1 ? (currentPage - 1) * 10 : "") }}</td>
                    <td
                        v-for="(column, columnIndex) in columns"
                        :key="columnIndex"
                        v-html="
                            (column.field
                                .toString()
                                .toLowerCase()
                                .includes('tel') &&
                                row['tel'] != null) ||
                            (column.field
                                .toString()
                                .toLowerCase()
                                .includes('phone') &&
                                row['phone'] != null)
                                ? row[column.field].replace('+98', 0)
                                : column.hasOwnProperty('subField')
                                ? row[column.field] != null && typeof row[column.field] != undefined
                                    ? row[column.field][column.subField]
                                    : ''
                                : row[column.field]
                        "
                    ></td>
                    <td
                        v-for="(customColumn, customColumnIndex) in customColumns"
                        :key="customColumnIndex + 'customColumn'"
                    >
                        {{ customColumn.func(row) }}
                    </td>
                    <td
                        v-if="
                            rows.hasOwnProperty('hasStatus') &&
                                row.hasOwnProperty('isActive') &&
                                row.isActive
                        "
                    >
                        <i class="ti-check text-success"></i>
                    </td>
                    <td
                        v-if="
                            rows.hasOwnProperty('hasStatus') &&
                                row.hasOwnProperty('isActive') &&
                                !row.isActive
                        "
                    >
                        <i class="ti-close text-danger"></i>
                    </td>
                    <td v-if="rows.hasOwnProperty('operations')" class="d-inline-block">
                        <router-link
                            :target="rows.operations[1].target"
                            v-for="(operation, index) in rows.operations[1]"
                            :key="index"
                            :to="{
                                name: rows.operations[0] + '.' + index,
                                params: {
                                    id: row.orderId || row.id || row.domainDataId || row.requestId
                                }
                            }"
                            :class="'d-inline-block ml-2 ' + operation.class"
                            :title="operation.title"
                            ><i :class="operation.icon + ' operationsIcon'"></i
                        ></router-link>
                    </td>
                </tr>
            </tbody>
        </table>
        <ul
            class="pagination pagination-circled"
            style="overflow-x: auto;"
            v-if="pages.length > 1 && !this.pagination && false"
        >
            <li class="page-item" v-if="currentPage > 1">
                <a class="page-link" href="#" v-on:click="prevPage"
                    ><i class="icon ion-ios-arrow-forward"></i
                ></a>
            </li>
            <li
                :class="currentPage == page ? 'page-item active' : 'page-item'"
                v-for="page in pages"
                :key="page"
            >
                <a
                    class="page-link"
                    href="#"
                    v-on:click="
                        (e) => {
                            changePage(e, page);
                        }
                    "
                    >{{ page }}</a
                >
            </li>
            <li class="page-item" v-if="pages.length != currentPage">
                <a class="page-link" href="#" v-on:click="nextPage"
                    ><i class="icon ion-ios-arrow-back"></i
                ></a>
            </li>
        </ul>

        <div v-if="!hasNoPagination">
            <Pagination
                :pages="pages"
                :currentPage="currentPage"
                :prevPageMethod="prevPage"
                :nextPageMethod="nextPage"
                :changePageMethod="changePage"
            />
            <span>تعداد کل ردیف ها : {{ dataTableCount }} ردیف</span>
        </div>
    </div>
</template>

<script>
import Pagination from "../../components/Partials/Pagination";
export default {
    name: "Index",
    props: [
        "rows",
        "columns",
        "customColumns",
        "count",
        "url",
        "operations",
        "callBackOperations",
        "pagination",
        "shippings",
        "postedData",
        "hasNoPagination"
    ],
    components: { Pagination },
    data() {
        return {
            showDataTableLoading: false,
            currentPage: 1,
            dataTableRows: [],
            dataTableCount: 0,
            pages: []
        };
    },
    methods: {
        prevPage(e) {
            this.currentPage = this.currentPage - 1;
            this.changePage(e, this.currentPage);
        },
        nextPage(e) {
            this.currentPage = this.currentPage + 1;
            this.changePage(e, this.currentPage);
        },
        changePage(e, page) {
            e.preventDefault();
            this.currentPage = page;
            this.showDataTableLoading = true;
            this.$api
                .post(this.url, { perPage: 10, page: this.currentPage, ...(this.postedData || {}) })
                .then(({ data }) => {
                    if (data.status) {
                        this.dataTableRows = [];
                        if (data.result) {
                            if (
                                this.url.toLowerCase().includes("order") &&
                                !this.url.toLowerCase().includes("bonus")
                            )
                                data.result.list.map((order) => {
                                    this.dataTableRows.push({
                                        ...order,
                                        fullName: order.firstName + " " + order.lastName,
                                        amount:
                                            new Intl.NumberFormat("en-IR", {
                                                maximumSignificantDigits: 20
                                            }).format(order.amount) + " ریال",
                                        shipping: this.shippings
                                            ? this.shippings[order.shippingId]
                                            : ""
                                    });
                                });
                            else this.dataTableRows = data.result.list;
                        } else if (data.list) {
                            if (
                                this.url.toLowerCase().includes("order") &&
                                !this.url.toLowerCase().includes("bonus")
                            )
                                data.list.map((order) => {
                                    this.dataTableRows.push({
                                        ...order,
                                        fullName: order.firstName + " " + order.lastName,
                                        amount:
                                            new Intl.NumberFormat("en-IR", {
                                                maximumSignificantDigits: 20
                                            }).format(order.amount) + " ریال",
                                        shipping: this.shippings
                                            ? this.shippings[order.shippingId]
                                            : ""
                                    });
                                });
                            else this.dataTableRows = data.result.list;
                        }
                        this.dataTableRows.operations = this.operations;
                        this.dataTableRows.callBackOperations = this.callBackOperations;
                    }
                })
                .finally(() => {
                    this.showDataTableLoading = false;
                });
        }
    },
    mounted() {
        $("#data-table").DataTable({
            responsive: true,
            searching: false,
            // sort: false,
            paging: this.pagination ? this.pagination : false,
            info: false
        });
        let calcPages = Math.ceil((this.dataTableCount ? this.dataTableCount : 10) / 10);
        calcPages = calcPages > 1 ? calcPages : 1;
        let pagesArray = [];
        for (let i = 1; i <= calcPages; i++) pagesArray.push(i);
        this.pages = pagesArray;
    },
    created() {
        this.dataTableRows = this.rows;
        this.dataTableCount = this.count;
    }
};
</script>
